/**
 * Heavy sabre (fx 'sabre', 'chain'): arcs in the art's element (a cross for chained cuts) and a spray of
 * its sparks.
 */
import { RAMPS } from '../fxSheets';
import { registerFx } from './registry';

registerFx(['sabre', 'chain'], (host) => ({
  skill: ({ src, tgt, s, look, style, tx, ty }) => {
    // Heavy sabre: arcs in the art's element (crimson for yang, violet for yin; a cross for
    // chained cuts) and a spray of sparks of it.
    const ramp = RAMPS[look.element];
    host.swingArc(src, style, ramp.body.join(','));
    if (s.fx === 'chain') host.swingArc(src, style === 'cleave' ? 'rising' : 'cleave', ramp.light.join(','));
    if (tgt)
      host.sparks(
        tx,
        ty - 14 * host.tall(tgt),
        host.iso.facing(src),
        14,
        [ramp.body, ramp.light, ramp.core].map((c) => `rgb(${c.join(',')})`),
        150,
      );
    host.sfx.swing();
  },
}));
